module.exports = "https://assets.meiaentrada.org.br/static/media/loading.a71d4738.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.svg
// module id = 102
// module chunks = 0